
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { FaLinkedin } from "react-icons/fa6";
import { ImFacebook2, ImYoutube } from "react-icons/im";
// import pic1 from "../../assets/Common/footer_upd.svg"

const pic1 = "https://storage.googleapis.com/think41-web-new/assets/Common/footer_upd.svg";
const pic2 = "https://storage.googleapis.com/think41-web-new/assets/Common/footer_frame.svg";

export default function Footer() {
  return (
    <footer
      className=" w-full relative text-white bg-cover  bg-center "
      style={{
        backgroundImage: `url(${pic1})`,
      }}
    >
      <div className="max-w-[1440px] md:px-[120px] px-[20px] mx-auto w-full flex flex-col py-[97px] md:pb-[68px] text-left">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row items-start justify-between">
          {/* SITEMAPS Section */}
          <div>
            <h2 className="text-lg font-bold mb-4 font-montserrat text-[20px]">
              SITEMAPS
            </h2>
            <nav className="flex flex-col space-y-2 font-montserrat text-[16px]">
              <Link to="/about" className="hover:underline">About Us</Link>
              <Link to="/offering-a" className="hover:underline">Solutions</Link>
              <Link to="/careers" className="hover:underline">Work with Us</Link>
              <Link to="/contact" className="hover:underline">Contact Us</Link>
            </nav>
          </div>

          {/* CONTACT Section */}
          <div className="mb-4">
            <h2 className="text-lg font-bold mb-4 font-montserrat text-[20px] md:mt-[0px] mt-[21px]">
              CONTACT
            </h2>
            <div className="flex flex-col space-y-2 font-montserrat text-[16px]">
              <p className="hover:underline">
                <a href="mailto:contact@think41.com">contact@think41.com</a>
              </p>
              <a href="https://www.google.com/maps/place/Think41/@12.9157289,77.6325263,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae15e4ab29f6a9:0x78164c186207e91e!8m2!3d12.9157289!4d77.6325263!16s%2Fg%2F11w2dlq4h4?entry=ttu&g_ep=EgoyMDI1MDUyMS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="hover:underline">2nd Floor, Obeya Gusto, HSR Layout,
                <br />Bengaluru, Karnataka 560102</a>
              <div
                className="flex space-x-4 md:border-t md:border-b border-none font-montserrat text-[16px] mt-2 pt-2 md:pt-0"
                style={{ borderColor: "rgba(26, 86, 219, 0.3)" }}
              >
                <a href="https://www.linkedin.com/company/think41/?originalSubdomain=in" target="_blank" rel="noopener noreferrer" aria-label="Linkedin" className="py-2">
                  <FaLinkedin className="h-5 w-5 hover:text-gray-300" />
                </a>
                <a href="https://www.instagram.com/think41corp/?hl=en" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="py-2">
                  <Instagram className="h-5 w-5 hover:text-gray-300" />
                </a>
                <a href="https://x.com/Think41corp" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="py-2">
                  <svg className="h-5 w-5 hover:text-gray-300" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
                <a href="https://www.facebook.com/Think41corp/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="py-2">
                  <ImFacebook2 className="h-[19px] w-5 hover:text-gray-300" />
                </a>
                <a href="https://www.youtube.com/channel/UCbn_X94Kc8KnmEKwVxxVJOQ" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="pt-[6px]">
                  <ImYoutube className="h-6 w-6 hover:text-gray-300" />
                </a>
              </div>
            </div>
          </div>

          {/* Logo */}
          <div className="self-start mt-6 md:mt-0">
            <div className="bg-white p-0 rounded-md flex items-center justify-center md:w-12 md:h-12">
              <img src={pic2} alt="Think41 Logo" className="w-[90px] h-[82px] object-contain" />
            </div>
          </div>
        </div>

        {/* Gradient Line Divider */}
        <div className="flex justify-center mt-[28px] mb-[31px]">
          <div
            className="w-full h-[1px]"
            style={{
              background: "linear-gradient(90deg, #FFF 0%, #7FAEE1 50.48%, #FFF 100%)",
            }}
          ></div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-auto flex flex-col gap-y-2 md:flex-row justify-between md:items-center">
          <Link to="/privacy-policy" className="hover:underline font-montserrat text-[14px]">
            Terms of Use & Privacy Policy
          </Link>
          <p className="md:mt-2 font-montserrat text-[14px]">
            © 2025 Think41. All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}


